import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import 'react-confirm-alert/src/react-confirm-alert.css';
import UsuarioFindDialogRedux from "./UsuarioFindDialogRedux";
import { importFile, importFileResponsaveis } from "./api-usuario";
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import { errorMessage } from '../../util/ConfirmAlertUtil';

const useStyles = makeStyles({
    container: {
        padding: '20px',
    },
    title: {
        padding: '20px',
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
});


export default function UsuarioImport() {
    const classes = useStyles();
    const [fileUsers, setFileUsers] = useState();
    const [message, setMessage] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const handleFileSelected = event => {
        setFileUsers(event.target.files[0]);
    }

    const handleUpload = () => {
        const fileFormData = new FormData();
        fileFormData.append('file', fileUsers);
        setIsLoading(true);
        importFile(fileFormData).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setMessage(data.message);
                }
            }
            setIsLoading(false);
        })
    }

    const handleUploadResponsaveis = () => {
        const fileFormData = new FormData();
        fileFormData.append('file', fileUsers);
        setIsLoading(true);
        importFileResponsaveis(fileFormData).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setMessage(data.message);
                }
            }
            setIsLoading(false);
        })
    }

    return (
        <div>
            <CssBaseline />
            <UsuarioFindDialogRedux />
            <Container className={classes.container} component={Paper}>
                <Typography className={classes.title} variant="h5">
                    Importar Usuários
                </Typography>
                <Grid container justify="space-around">
                    <input type="file" onChange={handleFileSelected} />

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleUpload}
                        disabled={isLoading}
                    >
                        {isLoading && <CircularProgress className={classes.loading} color="primary" size={20} />}
                        Fazer Upload
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleUploadResponsaveis}
                        disabled={isLoading}
                    >
                        {isLoading && <CircularProgress className={classes.loading} color="primary" size={20} />}
                        Fazer Upload Responsáveis
                    </Button>

                </Grid>
                <Typography className={classes.title} variant="h5">
                    {message}
                </Typography>
            </Container>

        </div>
    );
}